import { useEffect } from 'react'

let counter = 0

export const useBodyScroll = (scrollable: boolean) => {
  useEffect(() => {
    if (!scrollable) {
      ++counter
      document.body.classList.add('noscroll')

      return () => {
        --counter
        if (counter < 1) document.body.classList.remove('noscroll')
      }
    }
  }, [scrollable])
}
